<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('jobPosition.title')" icon="briefcase">
            <app-default-button
                v-if="$can('create_job_position')"
                :title="$addLabel('job_position')"
                @click="openJobPositionModal()"
            />
        </app-page-top-section>

        <app-table
            id="job-position-table"
            :options="options"
            @action="triggerActions"
        />

        <app-job-position-modal
            v-if="isJobPositionModalActive"
            v-model="isJobPositionModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
            :message="promptSubtitle"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
        />


    </div>
</template>

<script>
import JobPositionMixin from "../../../Mixins/Recruitment/JobPositionMixin";
import {axiosDelete, urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {JOBPOSITIONWEB} from "../../../../Config/ApiUrl";

export default {
    name: "Job-Position",
    mixins: [JobPositionMixin],
    data() {
        return {
            jobPosition: '',
            jobPositionId: '',
            jobPositions: [],
            selectedUrl: '',
            modalClass: '',
            promptIcon: '',
            promptSubtitle: '',
            jobPositionTitle: '',
            jobPositionUsers: '',
            isJobPositionModalActive: false,
            confirmationModalActive: false,
        }
    },
    created() {
        this.$store.dispatch('getStatuses', 'job_position')
    },
    watch: {
        isJobPositionModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        openJobPositionModal() {
            this.selectedUrl = '';
            this.isJobPositionModalActive = true;
        },
        triggerActions(row, action, active) {
            this.jobPositionId = row.id;
            this.promptIcon = action.icon;
            this.modalClass = action.modalClass;
            this.promptSubtitle = action.promptSubtitle;

            if (action.name === 'edit') {
                this.selectedUrl = `${action.url}/${row.id}`;
                this.isJobPositionModalActive = true;
            }
            if (action.key === 'view_details') {
                window.location = urlGenerator(`${JOBPOSITIONWEB}/${row.id}`)
                // Add logic to handle view details action
            }
            if (action.key === 'delete_job_position') {
                this.confirmationModalActive = true;
                this.promptAction = action.key;
                this.deleteUrl = `${action.url}/${row.id}`
                this.promptTitle = this.$t('are_you_sure');
                this.promptMessage = this.$t('jobPosition.you_are_going_to_remove_an_job_position_from_list');
            }
            else if (action.name === 'move-employee') {
                this.jobPositionId = row.id;
                this.jobPositionTitle = row.title;
            } else {
                this.getAction(row, action, active)
            }
        },
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
            window.location.reload();
        },
        triggerConfirm() {
            if (this.promptAction === 'delete_job_position') {
                this.removeJobPosition(this.deleteUrl);
            }
        },
        removeJobPosition(url) {
            this.loading = true;
            // Change axiosPatch to axiosDelete for deletion
            axiosDelete(url)
                .then(({data}) => {
                    this.confirmationModalActive = false;
                    this.toastAndReload(data.message, 'job-position-table');
                }).catch(({response}) => {
                this.toastException(response.data);
                this.confirmationModalActive = false;
            }).finally(() => this.closeConfirmation());
        }
    }
}
</script>
